import IApplicationRequest from "@/module/main/dto/origination-v2/IApplicationRequest";
import IOriginationApplicationClient from "@/module/main/dto/origination-v2/IOriginationApplicationClient";
import IFinancedSubjectBase from "@/module/main/dto/IFinancedSubjectBase";
import IOriginationContextRequest from "@/module/main/dto/IOriginationContextRequest";
import SourceSystem from "@/module/main/dto/SourceSystemEnum";

export default class ApplicationRequest implements IApplicationRequest
{
    constructor(
        public client: IOriginationApplicationClient,
        public financedSubject: IFinancedSubjectBase,
        public originationContext: IOriginationContextRequest,
        public sourceSystem: SourceSystem
    )
    {
    }
}
